
const {parse} = require('../html')
const layout = require('./add_visualiser.html')

const VISUALISERS = require('../visualiser')

const AddVisualiser = class {
    constructor(analysis, visualisers = VISUALISERS) {
        this.analysis = analysis
        this.visualisers = visualisers
        this.onadd = () => {}
    }
    dom() {
        const visualisers = this.visualisers
        const content = parse(layout, {visualisers}).querySelector('#content')
        visualisers.forEach(({add}, i) => {
            const visualiser = content.querySelector(`.type#v${i+1}`)
            if(!visualiser) return
            visualiser.addEventListener('click', () => {
                this.onadd(add(this.analysis))
            })
        })
        return content
    }
}

module.exports = AddVisualiser
